import React from 'react'
import className from 'classnames'

import range from './range'

import * as S from './styled'

const Pagination = ({
    instance: {
        pageOptions,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        gotoPage,
        pageIndex,
    },
    pageCount,
}) => {
    const previousClassName = 'page-item previous' + (canPreviousPage ? '' : ' disabled')
    const nextClassName = 'page-item next' + (canNextPage ? '' : ' disabled')

    return (
        <S.Pagination className="pagination !my-4 lg:!m-0">
            <li className={`${previousClassName} first`}>
                <button className="page-link" onClick={() => gotoPage(0)} data-test="first-page">
                    First
                </button>
            </li>
            <li className={previousClassName}>
                <button
                    className="page-link"
                    onClick={() => previousPage()}
                    data-test="previous-page"
                >
                    Previous
                </button>
            </li>
            {range(pageIndex, pageOptions.length, 4).map((option, i) => (
                <li
                    key={i}
                    className={className('page-item', {
                        active: option !== '...' && pageIndex === option - 1,
                    })}
                >
                    {option === '...' ? (
                        <span className="page-link disabled">{option}</span>
                    ) : (
                        <button
                            className="page-link"
                            onClick={() => gotoPage(option - 1)}
                            data-test={`page-${option}`}
                        >
                            {option}
                        </button>
                    )}
                </li>
            ))}
            <li className={nextClassName}>
                <button className="page-link" onClick={() => nextPage()} data-test="next-page">
                    Next
                </button>
            </li>
            <li className={`${nextClassName} last`}>
                <button
                    className="page-link"
                    onClick={() => gotoPage(pageCount - 1)}
                    data-test="last-page"
                >
                    Last
                </button>
            </li>
        </S.Pagination>
    )
}

export default Pagination
